export const worldAbi = [
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_projectId',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'donateEth',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
];
